export default __webpack_public_path__ + "static/media/subtitle-variations.3870d60a.png";